import { render, staticRenderFns } from "./photoAlbum.vue?vue&type=template&id=3dc763d4&scoped=true"
import script from "./photoAlbum.vue?vue&type=script&lang=ts"
export * from "./photoAlbum.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc763d4",
  null
  
)

export default component.exports